import { Controller } from "@hotwired/stimulus";

// Shows only the settings that apply: age limits and guests for individual
// registration, guests and the non-member price unless the event is members only, and
// onsite prices (in place of the registration deadline) when onsite registration is allowed.
export default class extends Controller {
  static targets = ["registrationType", "membersOnly", "individualOnly", "guestsSetting", "nonMemberOnly", "onsiteAllowed", "onsiteOnly", "registrationClosesSetting"];

  connect() {
    this.toggle();
  }

  toggle() {
    const individual = this.registrationTypeTarget.value === "individual";
    const membersOnly = this.membersOnlyTarget.checked;
    this.individualOnlyTargets.forEach((section) => {
      section.hidden = !individual;
    });
    this.guestsSettingTargets.forEach((section) => {
      section.hidden = membersOnly;
    });
    this.nonMemberOnlyTargets.forEach((section) => {
      section.hidden = membersOnly;
    });
    const onsite = this.onsiteAllowedTarget.checked;
    this.onsiteOnlyTargets.forEach((section) => {
      section.hidden = !onsite;
    });
    this.registrationClosesSettingTargets.forEach((section) => {
      section.hidden = onsite;
    });
  }
}
